/*
Clear Topcoats and Sealers
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Clear Topcoats and Sealers'
const id = 'J0ZsRZowNMGSIm6y7KyR'

export default {
  name,
  id,
  filters,
  headers,
  form
}
